import { APP_CONFIG } from 'mangools-commons/dist/configs/app';
import queryString from 'query-string';
import { parse } from 'sources/parsers/SerpResultDataParser';

import ErrorCodes from 'mangools-commons/dist/constants/ErrorCodes';
import HumanService from 'mangools-commons/dist/services/HumanService';
import { TechnicalErrorReportService } from 'mangools-commons/dist/services/TechnicalErrorReportService';

// Constants
const ENDPOINT = '/serps';

/**
 * Data source class handling communication
 * with API for serp result list data.
 */
class SerpResultSource {
    static getData({ accessToken, disableCache, page, params }) {
        let query = null;

        if (disableCache === true) {
            query = queryString.stringify({
                cacheTime: 0,
                kw: params.query,
                location_id: params.locationId,
                page,
            });
        } else {
            query = queryString.stringify({
                kw: params.query,
                location_id: params.locationId,
                page,
            });
        }

        const requestURL = `${APP_CONFIG.API_HOST}${APP_CONFIG.API_PATH}${ENDPOINT}?${query}`;

        return fetch(requestURL, {
            method: 'GET',
            mode: 'cors',
            headers: {
                'X-Access-Token': accessToken || '',
                'X-Human-Token': HumanService.gen(),
                'X-Mangools-Client': 'app',
            },
        })
            .then(response => {
                if (response.ok) {
                    // No SERP data results
                    if (response.status === 204) {
                        return {
                            error: false,
                            payload: null,
                        };
                    } else {
                        return response
                            .json()
                            .then(data => ({
                                error: false,
                                payload: parse(data),
                            }))
                            .catch(ex => {
                                const payload = {
                                    requestURL,
                                    status: ErrorCodes.PARSE_ERROR,
                                    text: ex.toString(),
                                };

                                TechnicalErrorReportService.report({ ...payload, method: 'GET' });

                                return { error: true, payload };
                            });
                    }
                } else {
                    return response.json().then(e => {
                        const payload = {
                            requestURL,
                            status: response.status,
                            text: e.error ? e.error.message : null,
                            type: e.error ? e.error.type : null,
                            retryAfter: e.error ? e.error.retry_after : null,
                        };

                        TechnicalErrorReportService.report({ ...payload, method: 'GET' });

                        return { error: true, payload };
                    });
                }
            })
            .catch(ex => {
                const payload = {
                    requestURL,
                    status: ErrorCodes.FETCH_ERROR,
                    text: ex.toString(),
                };

                TechnicalErrorReportService.report({ ...payload, method: 'GET' });

                return { error: true, payload };
            });
    }
}

export default SerpResultSource;
